import {amount_format} from 'components/config/Common'
import { BiWalletAlt } from "react-icons/bi";

const Notifcationbadge = ({max, min,totalamount}:props) => {
   
   max = Number(max)
   min = Number(min)
   
   let def =  max - min
   let disc = (def/max)*100
   disc = Math.round(disc);

   
      return(
       <button type="button" class="relative inline-flex items-center p-2 text-sm font-medium text-center text-white bg-accent rounded-lg hover:bg-accent focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-accent dark:focus:ring-blue-800">
         <BiWalletAlt className="w-5 h-5" />
        <span class="sr-only">Notifications</span>
        <div class="absolute inline-flex items-center justify-center px-4 text-xs font-bold text-white bg-secondary-color border-2 border-white rounded-full -top-2 -right-2 dark:border-gray-900">{amount_format(totalamount)}</div>
      </button>
      )
  

}

export default Notifcationbadge